import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'svg[mib-edit-icon]',
  template: `
    <svg:path
      d="M12.9688 5.375L10.625 3.01562L2.75 10.8906V13.25H5.10938L12.9688 5.375ZM10.1562 1.625L10.2656 1.54688L10.375 1.48438L10.5 1.45312L10.625 1.4375L10.75 1.45312L10.875 1.48438L10.9844 1.54688L11.0938 1.625L14.4062 4.95312L14.4844 5.0625L14.5312 5.1875L14.5625 5.3125V5.4375L14.5312 5.5625L14.4844 5.6875L14.4062 5.79688L5.84375 14.375L5.73438 14.4531L5.625 14.5156L5.5 14.5469L5.375 14.5625H2.03125L1.90625 14.5312L1.84375 14.5156L1.73438 14.4531L1.625 14.375L1.54688 14.2656L1.48438 14.1562L1.45312 14.0312L1.4375 13.9062V10.5625L1.46875 10.4375L1.48438 10.375L1.54688 10.2656L1.625 10.1562L10.1562 1.625Z" />
  `,
  host: {
    '[attr.viewBox]': 'viewBox()',
    class: 'mib-icon-default-size fill-current transition-colors',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditIcon {
  readonly viewBox = input<string>('0 0 16 16');
}
